module.exports = __webpack_public_path__ + "static/img/manual-27.090d4e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-27.png
// module id = Uwqm
// module chunks = 4